// extracted by mini-css-extract-plugin
export default {"wrap":"tE-z","fullWidth":"uE-z","searchPlacement":"vE-z","heading":"wE-z","items":"xE-z","featureCss":"yE-z","disabled":"zE-z","imgCss":"AE-z"};